(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/widget-page/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/templates/widget-page/assets/javascripts/init.js');

'use strict';

let isBottomSheetDoubleClick = false;
const _navigate = path => {
  if (isBottomSheetDoubleClick) {
    return;
  }
  isBottomSheetDoubleClick = true;
  const currentPathEncodedParams = svs.utils.url.currentPathEncodedParams();
  const fullPath = "".concat(path, "?returnUrl=").concat(currentPathEncodedParams);
  isBottomSheetDoubleClick = false;
  location.href = fullPath;
};
const renderBottomsheet = () => {
  const btn = svs.ui.button.partials.button({
    class: 'js-login-button-bottom-sheet',
    focus: true,
    block: true,
    content: 'Logga in',
    id: 'start-page-bottom-sheet-login'
  });
  const content = "<div class=\"f-center padding-xs-bottom-1 padding-xs-h-2 padding-xs-top-2\">".concat(btn, "</div>\n       <div class=\"f-center padding-xs-bottom-2\">\n         <a class=\"js-registration-link-bottom-sheet fc-navy u-text-decoration-underline\" id=\"start-page-bottom-sheet-register\">Bli kund</a>\n       </div>");
  const bottomSheet = new svs.ui.BottomSheet({
    classNames: 'bg-sport-100 bottom-sheet-sport ',
    transparent: true,
    isFixed: true,
    footerContent: content
  });
  bottomSheet.show();
  document.querySelector('.js-login-button-bottom-sheet').addEventListener('click', () => {
    svs.components.analytics.trackEvent({
      category: 'Navigation',
      action: 'bottom_sheet',
      opt_label: 'logga in'
    }, () => {
      _navigate(svs.core.urlMapping.get('loginHome'));
    });
  });
  document.querySelector('.js-registration-link-bottom-sheet').addEventListener('click', () => {
    svs.components.analytics.trackEvent({
      category: 'Navigation',
      action: 'bottom_sheet',
      opt_label: 'bli kund'
    }, () => {
      _navigate(svs.core.urlMapping.get('customerRegistrationHome'));
    });
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const widgetPageConfig = svs.widgetPageConfig.data.widgetPageConfig;
  const showBottomSheet = widgetPageConfig === null || widgetPageConfig === void 0 ? void 0 : widgetPageConfig.showBottomSheet;
  if (svs.core.detect.formfactor.mobile() && !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && showBottomSheet) {
    renderBottomsheet();
  }

  if (Modernizr.history && history.state && history.state.type && history.state.type === 'modal') {
    history.back();
  }
});

 })(window);